<template>
  <div class="goods-content">
    <!-- Loading -->
    <div class="goods-loading" v-if="isBusy">
      <TableSpiner />
    </div>
    <div class="goods-loading" v-else-if="!constructionId">
      <h2 class="text-center text-muted">
        Wybierz budowę dla której
        <br />chcesz zarejestrować zwrot wydanego materiału
      </h2>
    </div>
    <!-- results -->
    <template v-else>
      <div class="goods-loading" v-if="materials.length === 0">
        <div class="empty">
          <i class="empty-state fas fa-dolly"></i>
          <span class="empty-search">Brak wydanych materiałów</span>
        </div>
      </div>
      <template v-else>
        <div class="goods-breadcrumb">
          <b-breadcrumb class="breadcrumb">
            <h3>Wydane materiały</h3>
          </b-breadcrumb>
        </div>
        <!-- Materials -->
        <singleMaterial
          v-for="(material) in materials"
          :key="'m'+material.id"
          :material="material"
          @select="$emit('selectMaterial', $event)"
        />
      </template>
    </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ConstructionService from "@/services/construction.service";
import TableSpiner from "@/components/TableSpiner";
import singleMaterial from "./singleMaterial";

export default {
  components: { TableSpiner, singleMaterial },
  props: ["constructionId"],
  data() {
    return {
      isBusy: false
    };
  },
  watch: {
    // whenever question changes, this function will run
    constructionId: function(newConstructionID) {
      if (newConstructionID > 0) {
        this.isBusy = true;
        ConstructionService.getMaterials(this.constructionId)
          .then(materials => {
            this.$store.commit("materials/setMaterials", materials);
          })
          .finally(() => {
            this.isBusy = false;
          });
      }
    }
  },
  computed: {
    ...mapGetters("materials", ["materials"])
  },
  methods: {
  }
};
</script>